import React from 'react';
import { useTranslation } from 'react-i18next';

const CheckIcon = ({ done }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="shrink-0">
    <circle cx="8" cy="8" r="7" stroke={done ? 'rgb(16,185,129)' : 'rgb(75,85,99)'} strokeWidth="1.5" />
    {done
      ? <path d="M5 8l2 2 4-4" stroke="rgb(16,185,129)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      : <circle cx="8" cy="8" r="2" fill="rgb(75,85,99)" />
    }
  </svg>
);

const RoadmapSection = () => {
  const { t } = useTranslation();

  const available = t('roadmap.availableItems', { returnObjects: true });
  const coming    = t('roadmap.comingItems',    { returnObjects: true });

  return (
    <section className="py-24 bg-gray-950 border-t border-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block text-emerald-500 text-xs font-bold tracking-widest uppercase mb-3">
            {t('roadmap.label')}
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            {t('roadmap.title')}
          </h2>
          <p className="text-gray-400 text-lg max-w-xl mx-auto">
            {t('roadmap.subtitle')}
          </p>
        </div>

        {/* Two columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">

          {/* Available */}
          <div className="rounded-2xl bg-gray-900 border border-emerald-900/50 p-6 flex flex-col gap-4">
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-emerald-500" />
              <h3 className="text-white font-semibold text-sm uppercase tracking-widest">
                {t('roadmap.available')}
              </h3>
            </div>
            <ul className="flex flex-col gap-3">
              {available.map((item, i) => (
                <li key={i} className="flex items-center gap-3">
                  <CheckIcon done />
                  <span className="text-gray-300 text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Coming */}
          <div className="rounded-2xl bg-gray-900 border border-gray-700/50 p-6 flex flex-col gap-4">
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-gray-600" />
              <h3 className="text-gray-400 font-semibold text-sm uppercase tracking-widest">
                {t('roadmap.coming')}
              </h3>
            </div>
            <ul className="flex flex-col gap-3">
              {coming.map((item, i) => (
                <li key={i} className="flex items-center gap-3">
                  <CheckIcon done={false} />
                  <span className="text-gray-500 text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </div>

        </div>
      </div>
    </section>
  );
};

export default RoadmapSection;
